import { render } from "./ModalNuovoLead.vue?vue&type=template&id=6e7a3abc&scoped=true"
import script from "./ModalNuovoLead.vue?vue&type=script&lang=js"
export * from "./ModalNuovoLead.vue?vue&type=script&lang=js"

import "./ModalNuovoLead.vue?vue&type=style&index=0&id=6e7a3abc&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7a3abc"]])

export default __exports__